/**
 * Get the value of a query string from a URL
 * @url https://gomakethings.com
 * @param  {String} field The field to get the value of
 * @param  {String} url   The URL to get the value from [optional]
 * @return {String}       The value
 */
function getQueryString(field, url) {
	var href = url ? url : window.location.href;
	var reg = new RegExp("[?&]" + field + "=([^&#]*)", "i");
	var string = reg.exec(href);

	return string ? string[1] : null;
}

/**
 * Get the value of a cookie
 * @url https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 * @param  {String} name  The name of the cookie
 * @return {String}       The cookie value
 */
function getCookie(name) {
	var value = "; " + document.cookie;
	var parts = value.split("; " + name + "=");
	if (parts.length == 2) {
		return parts.pop().split(";").shift();
	}
	return null;
}

/**
 * Check if element is partially in viewport
 * @url ???
 * @param  {Element} elem The HTML Element
 * @return {Boolean}
 */
function isPartiallyInViewport(elem) {
	var bounding = elem.getBoundingClientRect();
	return (
		(bounding.top >= 0 && bounding.left >= 0) ||
		(bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			bounding.right <= (window.innerWidth || document.documentElement.clientWidth))
	);
}

/**
 * Check if element is fully in viewport
 * @url ???
 * @param  {Element} elem The HTML Element
 * @return {Boolean}
 */
function isFullyInViewport(elem) {
	var bounding = elem.getBoundingClientRect();
	return (
		bounding.top >= 0 &&
		bounding.left >= 0 &&
		bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}
